// coffee.jsx
import React from 'react';

const BuyMeACoffee = () => {
  return (
    <div className="fixed bottom-4 right-4 z-50">
      <a
        href="https://buymeacoffee.com/shiv031"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://cdn.buymeacoffee.com/buttons/v2/default-orange.png"
          alt="Buy Me A Coffee"
          className="h-12 transition-transform hover:scale-105"
        />
      </a>
    </div>
  );
};

export default BuyMeACoffee;